<template>
  <component
    :is="claimsIndexComponent"
    v-if="projectsStore.project"
    :project-id="projectId"
  />
</template>

<script setup lang="ts">
import useBoqLockRedirect from '@/composables/useBoqLockRedirect';
import { useProjectsStore } from '@/store/projects';
import { computed } from 'vue';
import ProgressClaimsIndex from './ProgressClaimsIndex.vue';
import ProgressClaimsIndexLite from './ProgressClaimsIndexLite.vue';

defineProps<{
  projectId: string;
}>();

const projectsStore = useProjectsStore();

useBoqLockRedirect();

const claimsIndexComponent = computed(() => {
  return projectsStore.project?.feature_flag_progress_claims_lite ? ProgressClaimsIndexLite : ProgressClaimsIndex;
});
</script>
